/**
 * Formats a number with commas.
 *
 * @param value - The number to format.
 * @returns The formatted number as a string.
 */
export const formatNumberWithCommas = (value: number): string => {
  return new Intl.NumberFormat('en-US').format(value);
};
